import React from 'react'
import { Box, Typography } from '@mui/material'

import { Cards } from 'src/legacy/components/mui'
import ParticipantHistoryList from 'src/participantHistory/ParticipantHistoryList'
import ParticipantHistoryForm from 'src/participantHistoryForm/ParticipantHistoryForm'

type Props = {
  uid: string
}
const ParticipantHistory = ({ uid }: Props) => (
  <Box mt={3} data-participant-history>
    <Box alignItems="center" display="flex" justifyContent="space-between" mb={1}>
      <Typography variant="h3">Participant History</Typography>
    </Box>
    <Cards>
      <ParticipantHistoryForm uid={uid} />
      <ParticipantHistoryList uid={uid} />
    </Cards>
  </Box>
)

export default ParticipantHistory
